export const numericoMask = (e) => {
    const { value } = e.target
    e.target.value = value
        .replace(/\D/g, '')
}